/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MySQL RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7MysqlSqlByIntervalParams,
  GetV7MysqlSqlListByIntervalParams,
  GetV7MysqlSqlListParams,
  GetV7MysqlSqlSummaryListParams,
  GetV7MysqlSqlTextParams,
  GetV7MysqlSqlsParams,
  GetV7MysqlTopSqlAnalysisParams,
  GetV7MysqlTopSqlParams,
  SqlByIntervalV7Response,
  SqlDetailV7Response,
  SqlListByIntervalResponse,
  SqlListResponse,
  SqlSummaryListResponse,
  SqlTextBySqlIdResponse,
  TopDiffSqlV7Response,
  TopSqlAnalysisV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary sqlByInterval
 */
export const getV7MysqlSqlByInterval = (
  params: MaybeRef<GetV7MysqlSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlByIntervalV7Response>(
    { url: `/api/v7/mysql/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7MysqlSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'mysql', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>> = ({
    signal,
  }) => getV7MysqlSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>
>;
export type GetV7MysqlSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlByInterval
 */

export function useGetV7MysqlSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlList
 */
export const getV7MysqlSqlList = (
  params?: MaybeRef<GetV7MysqlSqlListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListResponse>(
    { url: `/api/v7/mysql/sql-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlListQueryKey = (params?: MaybeRef<GetV7MysqlSqlListParams>) => {
  return ['api', 'v7', 'mysql', 'sql-list', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqlList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqlList>>> = ({ signal }) =>
    getV7MysqlSqlList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqlList>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlSqlList>>
>;
export type GetV7MysqlSqlListQueryError = ErrorType<unknown>;

/**
 * @summary sqlList
 */

export function useGetV7MysqlSqlList<
  TData = Awaited<ReturnType<typeof getV7MysqlSqlList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlSqlListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlListByInterval
 */
export const getV7MysqlSqlListByInterval = (
  params: MaybeRef<GetV7MysqlSqlListByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalResponse>(
    { url: `/api/v7/mysql/sql-list-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlListByIntervalQueryKey = (
  params?: MaybeRef<GetV7MysqlSqlListByIntervalParams>,
) => {
  return ['api', 'v7', 'mysql', 'sql-list-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlListByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlListByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>> = ({
    signal,
  }) => getV7MysqlSqlListByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlListByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>
>;
export type GetV7MysqlSqlListByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlListByInterval
 */

export function useGetV7MysqlSqlListByInterval<
  TData = Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlListByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlSummaryList
 */
export const getV7MysqlSqlSummaryList = (
  params: MaybeRef<GetV7MysqlSqlSummaryListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlSummaryListResponse>(
    { url: `/api/v7/mysql/sql-summary-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlSummaryListQueryKey = (
  params?: MaybeRef<GetV7MysqlSqlSummaryListParams>,
) => {
  return ['api', 'v7', 'mysql', 'sql-summary-list', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlSummaryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlSummaryListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>> = ({
    signal,
  }) => getV7MysqlSqlSummaryList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlSummaryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>
>;
export type GetV7MysqlSqlSummaryListQueryError = ErrorType<unknown>;

/**
 * @summary sqlSummaryList
 */

export function useGetV7MysqlSqlSummaryList<
  TData = Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlSummaryListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlText
 */
export const getV7MysqlSqlText = (
  params: MaybeRef<GetV7MysqlSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextBySqlIdResponse>(
    { url: `/api/v7/mysql/sql-text`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlTextQueryKey = (params?: MaybeRef<GetV7MysqlSqlTextParams>) => {
  return ['api', 'v7', 'mysql', 'sql-text', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlTextParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlText>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlTextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqlText>>> = ({ signal }) =>
    getV7MysqlSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqlText>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlSqlText>>
>;
export type GetV7MysqlSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary sqlText
 */

export function useGetV7MysqlSqlText<
  TData = Awaited<ReturnType<typeof getV7MysqlSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7MysqlSqlTextParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqlText>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlDetail
 */
export const getV7MysqlSqls = (
  params?: MaybeRef<GetV7MysqlSqlsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlDetailV7Response>(
    { url: `/api/v7/mysql/sqls`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlSqlsQueryKey = (params?: MaybeRef<GetV7MysqlSqlsParams>) => {
  return ['api', 'v7', 'mysql', 'sqls', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlSqlsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlSqls>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlSqlsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqls>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlSqlsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlSqls>>> = ({ signal }) =>
    getV7MysqlSqls(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlSqls>>,
    TError,
    TData
  >;
};

export type GetV7MysqlSqlsQueryResult = NonNullable<Awaited<ReturnType<typeof getV7MysqlSqls>>>;
export type GetV7MysqlSqlsQueryError = ErrorType<unknown>;

/**
 * @summary sqlDetail
 */

export function useGetV7MysqlSqls<
  TData = Awaited<ReturnType<typeof getV7MysqlSqls>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlSqlsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlSqls>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlSqlsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * excel 추출시에도 호출, 싱글뷰영역에서만 fromtime totime이 없으므로 DefaultFromTo 20분으로 적용
 * @summary [TOP SQL] 1) 싱글뷰 SQL & Query Error 영역 - 미니 그리드, 2) Trend Analysis: Top SQL 탭, 3) 멀티뷰 Queries Rank 박스 팝업
 */
export const getV7MysqlTopSql = (
  params?: MaybeRef<GetV7MysqlTopSqlParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopDiffSqlV7Response>(
    { url: `/api/v7/mysql/top-sql`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlTopSqlQueryKey = (params?: MaybeRef<GetV7MysqlTopSqlParams>) => {
  return ['api', 'v7', 'mysql', 'top-sql', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlTopSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlTopSql>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlTopSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlTopSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlTopSqlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlTopSql>>> = ({ signal }) =>
    getV7MysqlTopSql(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlTopSql>>,
    TError,
    TData
  >;
};

export type GetV7MysqlTopSqlQueryResult = NonNullable<Awaited<ReturnType<typeof getV7MysqlTopSql>>>;
export type GetV7MysqlTopSqlQueryError = ErrorType<unknown>;

/**
 * @summary [TOP SQL] 1) 싱글뷰 SQL & Query Error 영역 - 미니 그리드, 2) Trend Analysis: Top SQL 탭, 3) 멀티뷰 Queries Rank 박스 팝업
 */

export function useGetV7MysqlTopSql<
  TData = Awaited<ReturnType<typeof getV7MysqlTopSql>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlTopSqlParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlTopSql>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlTopSqlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topSqlAnalysis
 */
export const getV7MysqlTopSqlAnalysis = (
  params?: MaybeRef<GetV7MysqlTopSqlAnalysisParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopSqlAnalysisV7Response>(
    { url: `/api/v7/mysql/top-sql-analysis`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7MysqlTopSqlAnalysisQueryKey = (
  params?: MaybeRef<GetV7MysqlTopSqlAnalysisParams>,
) => {
  return ['api', 'v7', 'mysql', 'top-sql-analysis', ...(params ? [params] : [])] as const;
};

export const getGetV7MysqlTopSqlAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlTopSqlAnalysisParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MysqlTopSqlAnalysisQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>> = ({
    signal,
  }) => getV7MysqlTopSqlAnalysis(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>,
    TError,
    TData
  >;
};

export type GetV7MysqlTopSqlAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>
>;
export type GetV7MysqlTopSqlAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary topSqlAnalysis
 */

export function useGetV7MysqlTopSqlAnalysis<
  TData = Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7MysqlTopSqlAnalysisParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7MysqlTopSqlAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MysqlTopSqlAnalysisQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
